module.exports = __webpack_public_path__ + "img/ArgCroacia3.1261d91d.jpg";